import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_add_ship = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/ship`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_ship = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/ship`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_create_ship_crew_account = async (shipId, post) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/ship/${shipId}/crew-account`;
    return customAxios.post(url, { post }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_reset_ship_crew_account_password = async (shipId, post) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/ship/${shipId}/crew-account/${post}/temporary-password`;
    return customAxios.post(url, {}, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_ships = async (page, limit, payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/ship/${page}/${limit}${payload ? `?payload=${payload}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_unassigned_vessels = async (page, limit, projectId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/project-and-vessels/unassigned-vessels/${page}/${limit}/${projectId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_assign_vessels = async (payload, projectId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/project-and-vessels/assign/${projectId}`;
    return customAxios.put(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_ship_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/ship/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_ship_owner = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipOwner`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_ship_owners = async (page, limit, payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipOwner/${page}/${limit}${payload ? `?payload=${payload}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_ship_owner_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipOwner/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_ship_owner = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipOwner`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_project = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/project-and-vessels/project`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => res.data);
};

export const v3_edit_project = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/project-and-vessels/project`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => res.data);
};

export const v3_projects = async (page, limit, payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/project-and-vessels/project/${page}/${limit}${payload ? `?payload=${payload}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => res.data);
};

export const v3_project_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/project-and-vessels/project/${id}`;
    return customAxios.patch(url, { visibility }, getAuthHeader()).then((res) => res.data);
};
